/** Compact reusable emoji quick-pick row. Tap a tile to set the value;
 *  tap the same tile (or "Clear") to remove. Curated to a small set
 *  appropriate for the Storylo cause categories — we deliberately avoid
 *  emojis that read flippant on trauma stories (😂 🔥 🎉 …). */

const PICKS = [
  "🐎", "🐕", "🐈", "🐾",
  "🎗️", "🎀", "💜",
  "💚", "🌱",
  "🤍", "🌟",
  "🌍", "🌳", "🌊",
  "❤️", "✨",
];

export default function EmojiQuickPick({ value, onChange, testId }) {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testId || "emoji-quick-pick"}>
      {PICKS.map((e) => (
        <button
          key={e}
          type="button"
          onClick={() => onChange(value === e ? "" : e)}
          aria-label={`Use ${e}`}
          aria-pressed={value === e}
          className={`w-8 h-8 rounded-md flex items-center justify-center text-base leading-none border transition-colors ${value === e ? "border-[color:var(--accent)] bg-[color:var(--accent)]/10" : "border-white/10 hover:border-white/40"}`}
        >
          {e}
        </button>
      ))}
      {value && (
        <button
          type="button"
          onClick={() => onChange("")}
          className="w-auto px-2 h-8 rounded-md flex items-center justify-center text-[10px] uppercase tracking-wider border border-white/10 hover:border-red-400 hover:text-red-300 transition-colors"
          aria-label="Clear emoji"
        >
          Clear
        </button>
      )}
    </div>
  );
}
